export default "__VITE_ASSET__DnTqIgbn__"